import { isUnknownObject } from '~/shared/utils/guards'
import { BaseModel, fillOwnProperties } from '~/shared/model'
import { toCroppedImage } from '~/shared/utils/image'

export default class EmployersTasksItemEmployerModel extends BaseModel {
  static override constructorName = 'EmployersTasksItemEmployerModel'

  public slug: string = ''
  public name: string = ''
  public logo: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.logo = toCroppedImage(data.logo)
    }
  }
}
